import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import type React from 'react';
import { colors } from '../theme/colors';

export interface ProjectData {
  projectNumber: string;
  month: string;
}

export const exportGroupReportToPDF = async (
  pdfContainerRef: React.RefObject<HTMLDivElement>,
  projectData: ProjectData,
  setIsExporting: (value: boolean) => void
): Promise<void> => {
  if (!pdfContainerRef.current || !projectData) {
    return;
  }

  setIsExporting(true);
  try {
    const parentElement = pdfContainerRef.current.parentElement;
    const originalParentPadding = parentElement?.style.padding || '';
    const originalParentDisplay = parentElement?.style.display || '';
    const originalParentMargin = parentElement?.style.margin || '';

    if (parentElement) {
      parentElement.style.padding = '0';
      parentElement.style.margin = '0';
      parentElement.style.display = 'block';
    }

    await new Promise((resolve) => setTimeout(resolve, 300));

    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
      compress: true,
    });

    pdf.setProperties({
      title: 'Kundenbericht',
      subject: 'Customer Report',
      author: 'TLT System',
    });

    const pdfWidth = pdf.internal.pageSize.getWidth();

    const pageElements = document.querySelectorAll('[data-pdf-export="true"]');

    for (let pageIndex = 0; pageIndex < pageElements.length; pageIndex++) {
      const pageElement = pageElements[pageIndex] as HTMLElement;
      
      if (pageIndex > 0) {
        pdf.addPage();
      }

      const originalBoxShadow = pageElement.style.boxShadow;
      pageElement.style.boxShadow = 'none';

      await new Promise((resolve) => setTimeout(resolve, 100));

      const canvas = await html2canvas(pageElement, {
        scale: 3,
        useCORS: true,
        logging: false,
        backgroundColor: colors.neutral.white,
        width: pageElement.offsetWidth,
        height: pageElement.offsetHeight,
        allowTaint: false,
        foreignObjectRendering: false,
      });

      pageElement.style.boxShadow = originalBoxShadow;

      const imgData = canvas.toDataURL('image/png', 1.0);
      const imgWidth = pdfWidth;
      const imgHeight = (canvas.height / canvas.width) * pdfWidth;

      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight, undefined, 'SLOW');
    }

    if (parentElement) {
      parentElement.style.padding = originalParentPadding;
      parentElement.style.margin = originalParentMargin;
      parentElement.style.display = originalParentDisplay;
    }

    const sanitizedProjectNumber = projectData.projectNumber.replace(/[^a-zA-Z0-9_-]/g, '_');
    const sanitizedMonth = projectData.month.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_-]/g, '_');
    const fileName = `Kundenbericht_${sanitizedProjectNumber}_${sanitizedMonth}.pdf`;
    pdf.save(fileName);
  } catch (error) {
    console.error('Error generating PDF:', error);
    alert('Fehler beim Erstellen der PDF-Datei. Bitte versuchen Sie es erneut.');
  } finally {
    setIsExporting(false);
  }
};
